

exports.__esModule = true;
exports.$xoTokenizationInfoPageRoute = undefined;

var _index = require('squid/index');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoTokenizationInfoPageRoute = exports.$xoTokenizationInfoPageRoute = _index.$Route.extend('$xoTokenizationInfoPageRoute', {
    path: 'tokenizationInfo',
    directive: _directive2['default'],
    titleContent: 'Tokenization Info Page',
    trackingData: {
        fptiState: 'tokenizationInfo'
    },

    children: []
});

angular.value("$xoTokenizationInfoPageRoute", $xoTokenizationInfoPageRoute);
_index.$Route;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-tokenization-info/route.js
// module id = ./pages/xo-tokenization-info/route.js
// module chunks = 0